import { forwardRef } from "react";
import { Link as RRLink, NavLink as RRNavLink, Navigate, useParams, useNavigate } from "react-router-dom";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "@/i18n";

// Prepende il prefisso lingua ai path interni assoluti ("/chi-siamo" -> "/it/chi-siamo").
// Lascia intatti: link esterni, mailto/tel, path già con prefisso lingua.
export const localizeTo = (to, lang) => {
  const l = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
  if (typeof to !== "string") return to;
  if (!to.startsWith("/")) return to; // relativo o esterno
  if (/^\/(mailto:|tel:)/.test(to)) return to;
  const firstSeg = to.split("/")[1] || "";
  if (SUPPORTED_LANGS.includes(firstSeg)) return to; // già localizzato
  return `/${l}${to === "/" ? "" : to}`;
};

export const useLang = () => {
  const { lang } = useParams();
  return SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
};

export const useLangNavigate = () => {
  const navigate = useNavigate();
  const lang = useLang();
  return (to, opts) => navigate(localizeTo(to, lang), opts);
};

export const Link = forwardRef(({ to, ...props }, ref) => {
  const lang = useLang();
  return <RRLink ref={ref} to={localizeTo(to, lang)} {...props} />;
});
Link.displayName = "LangLink";

export const LangRedirect = ({ to }) => {
  const lang = useLang();
  return <Navigate to={localizeTo(to, lang)} replace />;
};

export const NavLink = forwardRef(({ to, ...props }, ref) => {
  const lang = useLang();
  return <RRNavLink ref={ref} to={localizeTo(to, lang)} {...props} />;
});
NavLink.displayName = "LangNavLink";
